/**
 * Rótulos do catálogo de períodos (espelho de backend/apps/core/periodos.py).
 *
 * As páginas usam isto só enquanto a primeira resposta não chega; a lista definitiva
 * (chaves, ordem e rótulos) vem da API.
 */
export const ROTULOS_PERIODO = {
  ytd: 'YTD',
  '30d': '30D',
  '6m': '6M',
  '1a': '1A',
  '2a': '2A',
  '3a': '3A',
  '5a': '5A',
  '10a': '10A',
  '20a': '20A',
  max: 'Completo',
} as const;

export interface OpcaoPeriodo {
  valor: string;
  rotulo: string;
}

export type ChavePeriodo = keyof typeof ROTULOS_PERIODO;

export function opcoesPeriodo(chaves: ChavePeriodo[]): OpcaoPeriodo[] {
  return chaves.map((valor) => ({ valor, rotulo: ROTULOS_PERIODO[valor] }));
}
